import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { FormHeading } from "../../Layouts/Heading";
import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import * as yup from "yup";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import styled from "styled-components";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import {
    getSingleLead,
    updateLead,
    reset,
} from "../../Redux/LeadsSlice/LeadsSlice";
import { saveObj } from "../../Redux/SaveObjToUpdate/SaveSlice";
import {
    getAllUsersWihtoutPage,
    reset as userReset,
} from "../../Redux/UserSlice/UserSlice";

///////////////////////////////////////////

const validationSchema = yup.object({
    first_name: yup
        .string("Enter your First Name")
        .required("First Name is required"),
    customer_type: yup.string("").required("Customer Type is required"),
    last_name: yup.string("").required(),
    phone: yup.string("").required(),
    is_phone_receives_txt: yup.string("").required(),
    mobile: yup.string("").required(),
    is_mobile_receives_txt: yup.string("").required(),
    email: yup.string("").required(),
    preferred_language: yup.string("").required(),
    is_hoa: yup.string("").required(),
    street: yup.string("").required(),
    location: yup.string("").required(),
    country_id: yup.string("").required(),
    user_id: yup.string("").required(),
    state_id: yup.string("").required(),
    building_type: yup.string("").required(),
    time_to_contact: yup.string("").required(),
    way_to_contact: yup.string("").required(),
    is_decision_maker_present: yup.string("").required(),
    house_ownership: yup.string("").required(),
    zip_code: yup.string("").required(),
});

const EditLead = () => {
    const { edit, id } = useParams();
    const dispatch = useDispatch();

    const { allUsers } = useSelector((state) => state.users);
    const all_users = allUsers?.data || [];

    useEffect(() => {
        const getLead = async () => {
            await dispatch(getSingleLead(id));
            await dispatch(reset());
        };
        getLead();

        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();

        const GetAllUsers = async () => {
            await dispatch(getAllUsersWihtoutPage());
            await dispatch(userReset());
        };
        GetAllUsers();
        if (isError) {
            toast.error(massage);
        }
        // dispatch(reset());
    }, [id]);

    const { singleLead, isError, isSuccess, isLodaing, massage } = useSelector(
        (state) => state.leads
    );
    const lead = singleLead ? singleLead?.data : "";

    const loadingLeads = useSelector((state) => state.leads.isLodaing);
    const successLeads = useSelector((state) => state.leads.isSuccess);
    const massageLeads = useSelector((state) => state.leads.massage);
    const errorLeads = useSelector((state) => state.leads.isError);

    const { states, isStatesloading } = useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;

    const formik = useFormik({
        initialValues: {
            id: lead?.id,
            customer_type: "test",
            first_name: "",
            last_name: "",
            phone: "",
            is_phone_receives_txt: false,
            mobile: "",
            is_mobile_receives_txt: false,
            email: "",
            preferred_language: "",
            is_hoa: false,
            street: "",
            location: "",
            country_id: "",
            user_id: "",
            state_id: "",
            building_type: "",
            time_to_contact: "",
            way_to_contact: "",
            is_decision_maker_present: false,
            house_ownership: "",
            zip_code: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            // const formData = new FormData();
            // formData.append("_method", "PUT");
            // formData.append("panel_id", id);
            await dispatch(updateLead(values));
            await CallNotificationMethod();
        },
    });
    const CallNotificationMethod = async () => {
        await dispatch(reset());
        if (successLeads) {
            toast.success("Lead Updated Successfully");
        }
    };

    useEffect(() => {
        if (lead.data == undefined) {
            formik.values.id = id;
            formik.values.customer_type = lead?.lead?.customer_type;
            formik.values.first_name = lead?.lead?.first_name;
            formik.values.last_name = lead?.lead?.last_name;
            formik.values.phone = lead?.lead?.phone;

            if (lead?.lead?.is_phone_receives_txt == 1)
                formik.values.is_phone_receives_txt = true;
            else formik.values.is_phone_receives_txt = false;

            formik.values.mobile = lead?.lead?.mobile;

            if (lead?.lead?.is_mobile_receives_txt == 1)
                formik.values.is_mobile_receives_txt = true;
            else formik.values.is_mobile_receives_txt = false;

            formik.values.email = lead?.lead?.email;
            formik.values.preferred_language = lead?.lead?.preferred_language;

            if (lead?.lead?.is_hoa == 1) formik.values.is_hoa = true;
            else formik.values.is_hoa = false;

            formik.values.street = lead?.lead?.street;
            formik.values.location = lead?.lead?.location;
            formik.values.country_id = lead?.lead?.country_id;
            formik.values.user_id = lead?.lead?.user_id;
            formik.values.state_id = lead?.lead?.state_id;
            formik.values.building_type = lead?.lead?.building_type;
            formik.values.time_to_contact = lead?.lead?.time_to_contact;
            formik.values.way_to_contact = lead?.lead?.way_to_contact;
            formik.values.is_decision_maker_present =
                lead?.lead?.is_decision_maker_present;
            formik.values.house_ownership = lead?.lead?.house_ownership;
            formik.values.zip_code = lead?.lead?.zip_code;
        }
    }, [lead]);

    useEffect(() => {
        if (errorLeads) {
            toast.error(massageLeads);
        }
    }, [errorLeads, massageLeads]);

    return (
        <>
            <FormContainer>
                <FormHeading>Edit Lead </FormHeading>
                {isLodaing && <LoadingAnimation />}
                {!isLodaing && !isError && (
                    // {!isError && !isSuccess && (
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="first_name"
                                    name="first_name"
                                    label="First Name"
                                    value={formik.values.first_name || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.first_name &&
                                        Boolean(formik.errors.first_name)
                                    }
                                    helperText={
                                        formik.touched.first_name &&
                                        formik.errors.first_name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="last_name"
                                    name="last_name"
                                    label="last_name"
                                    value={formik.values.last_name || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.last_name &&
                                        Boolean(formik.errors.last_name)
                                    }
                                    helperText={
                                        formik.touched.last_name &&
                                        formik.errors.last_name
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="phone"
                                    name="phone"
                                    label="Phone"
                                    value={formik.values.phone || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.phone &&
                                        Boolean(formik.errors.phone)
                                    }
                                    helperText={
                                        formik.touched.phone &&
                                        formik.errors.phone
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel>
                                    {" "}
                                    Is Phone Receives Txt :{" "}
                                </InputLabel>
                                <Switch
                                    id="is_phone_receives_txt"
                                    name="is_phone_receives_txt"
                                    checked={
                                        formik.values.is_phone_receives_txt
                                    }
                                    onChange={formik.handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="mobile"
                                    name="mobile"
                                    label="Mobile"
                                    value={formik.values.mobile || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.mobile &&
                                        Boolean(formik.errors.mobile)
                                    }
                                    helperText={
                                        formik.touched.mobile &&
                                        formik.errors.mobile
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel>
                                    {" "}
                                    Is Mobile Receives Txt :{" "}
                                </InputLabel>
                                <Switch
                                    id="is_mobile_receives_txt"
                                    name="is_mobile_receives_txt"
                                    checked={
                                        formik.values.is_mobile_receives_txt
                                    }
                                    onChange={formik.handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    label="Email"
                                    value={formik.values.email || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.email &&
                                        Boolean(formik.errors.email)
                                    }
                                    helperText={
                                        formik.touched.email &&
                                        formik.errors.email
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="preferred_language"
                                    name="preferred_language"
                                    label="Preferred Language"
                                    value={
                                        formik.values.preferred_language || ""
                                    }
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.preferred_language &&
                                        Boolean(
                                            formik.errors.preferred_language
                                        )
                                    }
                                    helperText={
                                        formik.touched.preferred_language &&
                                        formik.errors.preferred_language
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel> is_hoa : </InputLabel>
                                <Switch
                                    id="is_hoa"
                                    name="is_hoa"
                                    checked={formik.values.is_hoa}
                                    onChange={formik.handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="street"
                                    name="street"
                                    label="Street"
                                    value={formik.values.street || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.street &&
                                        Boolean(formik.errors.street)
                                    }
                                    helperText={
                                        formik.touched.street &&
                                        formik.errors.street
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="location"
                                    name="location"
                                    label="Location"
                                    value={formik.values.location || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.location &&
                                        Boolean(formik.errors.location)
                                    }
                                    helperText={
                                        formik.touched.location &&
                                        formik.errors.location
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl
                                    fullWidth
                                    // required={true}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        Country :
                                    </InputLabel>
                                    <Select
                                        id="country_id"
                                        name="country_id"
                                        label="State"
                                        // required={true}
                                        value={formik.values.country_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="">
                                            Select The User Country
                                        </MenuItem>
                                        {/* {AllStates?.map((key) => (
                        {key.name}
                    ))} */}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl
                                    fullWidth
                                    // required={true}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        // required={true}
                                        value={formik.values.state_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl
                                    fullWidth
                                    // required={true}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        Building Type
                                    </InputLabel>
                                    <Select
                                        id="building_type"
                                        name="building_type"
                                        label="Building Type"
                                        required={true}
                                        value={
                                            formik.values.building_type || ""
                                        }
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="">
                                            {" "}
                                            Select Any Buliding Type{" "}
                                        </MenuItem>
                                        <MenuItem value="single_family">
                                            Single Family
                                        </MenuItem>
                                        <MenuItem value="trailer">
                                            Trailer
                                        </MenuItem>
                                        <MenuItem value="town_home">
                                            Town Home
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl
                                    fullWidth
                                    // required={true}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        Customer Type
                                    </InputLabel>
                                    <Select
                                        id="customer_type"
                                        name="customer_type"
                                        label="Customer Type"
                                        required={true}
                                        value={
                                            formik.values.customer_type || ""
                                        }
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="">
                                            {" "}
                                            Select Any Customer Type{" "}
                                        </MenuItem>
                                        <MenuItem value="residential">
                                            Residential
                                        </MenuItem>
                                        <MenuItem value="commercial">
                                            Rommercial
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="time_to_contact"
                                    name="time_to_contact"
                                    label="time_to_contact"
                                    value={formik.values.time_to_contact || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.time_to_contact &&
                                        Boolean(formik.errors.time_to_contact)
                                    }
                                    helperText={
                                        formik.touched.time_to_contact &&
                                        formik.errors.time_to_contact
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Way To Contact
                                    </InputLabel>
                                    <Select
                                        id="way_to_contact"
                                        name="way_to_contact"
                                        label="Way To Contact"
                                        required={true}
                                        value={
                                            formik.values.way_to_contact || ""
                                        }
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem value="">
                                            Sekect Any Way To Contact
                                        </MenuItem>
                                        <MenuItem value="phone">Phone</MenuItem>
                                        <MenuItem value="email">Email</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>{" "}
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    name="email"
                                    label="Email"
                                    value={formik.values.email || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.email &&
                                        Boolean(formik.errors.email)
                                    }
                                    helperText={
                                        formik.touched.email &&
                                        formik.errors.email
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel>
                                    {" "}
                                    Is Decision Maker Present :{" "}
                                </InputLabel>
                                <Switch
                                    id="is_decision_maker_present"
                                    name="is_decision_maker_present"
                                    checked={
                                        formik.values.is_decision_maker_present
                                    }
                                    onChange={formik.handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl
                                    fullWidth
                                    // required={true}
                                >
                                    <InputLabel id="demo-simple-select-label">
                                        Users :
                                    </InputLabel>
                                    <Select
                                        id="user_id"
                                        name="user_id"
                                        label="State"
                                        // required={true}
                                        value={formik.values.user_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        {all_users.map((user, index) => (
                                            <MenuItem
                                                value={user.id}
                                                key={index}
                                            >
                                                {user.name + " : " + user.email}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {loadingLeads ? "loading..." : "Edit"}
                        </PrimaryButton>
                    </form>
                )}
            </FormContainer>
        </>
    );
};

const FormContainer = styled.div`
    padding: 4rem;
    margin: 1rem auto;
    background: var(--white);
    box-shadow: 0 5px 8px 0 var(--box-shadow);
    border-radius: 1rem;
    width: 70%;
`;

export default EditLead;
